import React, { useState } from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import Footer from '../components/Footer'; // Import the Footer component

const PartnershipCard = ({ title, description }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  return (
    <Card 
      className={`shadow-sm p-3 mb-4 bg-white rounded border transition-all cursor-pointer ${
        isHovered ? 'shadow-xl border-black scale-105' : 'border-gray-300'
      } ${isClicked ? 'bg-gray-900 text-white' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => setIsClicked(!isClicked)}
      style={{ transition: 'transform 0.3s ease, box-shadow 0.3s ease' }}
    >
      <Card.Body>
        <Card.Title className="text-dark fw-bold">{title}</Card.Title>
        <Card.Text className="text-muted">{description}</Card.Text>
      </Card.Body>
    </Card>
  );
};

const Partnerships = () => {
  const partnershipList = [
    {
      title: "Chiropractor",
      description: "We welcome chiropractors interested in collaborating with us to provide effective rehabilitation for individuals recovering from motor vehicle accidents."
    },
    {
      title: "Lawyer",
      description: "We seek legal professionals specializing in motor vehicle accidents to assist our clients in navigating legal claims and insurance processes."
    },
    {
      title: "Physiotherapist",
      description: "Join us as a physiotherapist to provide specialized rehabilitation and pain management for accident survivors."
    },
    {
      title: "Massage Therapist",
      description: "We are looking to partner with massage therapists to help clients manage pain and improve mobility post-accident."
    },
    {
      title: "Occupational Therapist",
      description: "If you are an occupational therapist, we invite you to collaborate with us in assisting clients with functional recovery and rehabilitation."
    },
    {
      title: "Psychologist (MVA & WSIB)",
      description: "We are looking for psychologists who specialize in Motor Vehicle Accidents (MVA) and Workplace Safety and Insurance Board (WSIB) cases to support clients with trauma recovery."
    }
  ];

  return (
    <>
      <Container className="mt-5">
        <Row className="justify-content-center text-center mb-4">
          <Col lg={8}>
            <Image 
              src="/images/partnership.png" 
              alt="Partnerships" 
              fluid 
              className="rounded shadow mb-3"
            />
            <h1 className="fw-bold text-dark">Partnerships</h1>
            <p className="text-muted">Please contact us if you are interested in forming a partnership with us in the following roles:</p>
          </Col>
        </Row>
        <Row className="flex-column">
          {partnershipList.map((partnership, index) => (
            <Col key={index} className="mb-4">
              <PartnershipCard {...partnership} />
            </Col>
          ))}
        </Row>
      </Container>

      {/* Footer Section */}
      <Footer />
    </>
  );
};

export default Partnerships;
